import { Pipe, PipeTransform } from '@angular/core';
import { LssDeploymentEntity } from '../store/deployment.datamodel';

/**
 * Pipe to determine if a given entity is excluded, taking into account deployment of parent entities and exclusions.
 */
@Pipe({
    name: 'isEntityExcluded',
    standalone: false
})
export class IsEntityExcludedPipe implements PipeTransform {

  transform(entity: LssDeploymentEntity): boolean {
    if (entity.deployedParent && entity.excludedParent) {
      return entity.deployedParent.depth < entity.excludedParent.depth;
    }
    return entity.excludedParent !== undefined || entity.isExcluded;
  }

}

